module.exports = __webpack_public_path__ + "static/img/9.5a34ace.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/9.png
// module id = kmUv
// module chunks = 0